import React from "react";
export const IconBackArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 18L6 10L14 2"
        stroke="#245CEA"
        strokeWidth="1.47727"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
